<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <template>
            <div id="user-edit-tab-info">
              <!-- Content Row -->
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <!--<vs-input
                    class="w-full mt-4"
                    label="Operation Category"
                    v-model="operation_data.operationcategory.name_en"
                    disabled
                  />
                  <br />-->
                  <div class="w-full mt-0">
                    <div style="font-size:85%">Invoice NR</div>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vx-input-group class="mt-0">
                            <vs-input
                              style="background-color:#95bea6; border: 2px solid #95bea6;border-radius: 5px;"
                              v-validate="'required'"
                              name="invoice number"
                              v-model="dataInvoiceNr"
                              size="default"
                            />
                          </vx-input-group>

                          <span
                            v-show="errors.has('invoice number')"
                            class="text-danger"
                          >{{ errors.first('invoice number') }}</span>
                        </div>
                    </div>
                  <p class="w-full mt-4" style="font-size:85%">
                    &nbsp;Operation Date
                    <datepicker
                      :inline="false"
                      v-model="operation_data.date"
                      @input="changeDateInvoice()"
                    ></datepicker>
                  </p>
                  </div>
                  <div class="w-full mt-4">
                    <div style="font-size:85%">Payment Status</div>
                    <div class="vx-row"> 
                      <div class="vx-col w-full">
                        <v-select :options="data_option_payment_status" v-model="statusId" />
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    
                    <div class="vx-row">
                      <div class="vx-col w-1/4">
                      <div style="font-size:85%">Advance Payment (%)</div>
                        <vs-input
                          v-validate="'required|decimal'"
                          v-model="dataAdvancePct"
                          class="w-full"
                          name="Advance Payment %"
                          @input="calculateAdvanceFromPctInput()"
                        />
                        <span
                          v-show="errors.has('Advance Payment %')"
                          class="text-danger"
                        >{{ errors.first('Advance Payment %') }}</span>
                      </div>
                      <div class="vx-col w-1/4">
                      <div style="font-size:85%">Advance Payment (EUR)</div>
                        <vs-input
                          v-validate="'required|decimal'"
                          v-model="dataAdvanceEur"
                          class="w-full"
                          name="Advance Payment EUR"
                          @input="calculateAdvanceFromEurInput()"
                        />
                        <span
                          v-show="errors.has('Advance Payment EUR')"
                          class="text-danger"
                        >{{ errors.first('Advance Payment EUR') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="w-full mt-0">
                    <div style="font-size:85%">Client</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select
                          autocomplete
                          :options="data_option_people_name"
                          v-model="personId"
                          @input="getBillingAndDeliveryAddressList(true);"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    <div style="font-size:85%">Billing Address</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select
                          :options="data_option_billing_address"
                          v-model="billingAddressId"
                        / :disabled="addressesLoading">
                        <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                             choisir une adresse quelconque du client a sa place. -->
                        <span v-if="billingAddressUnlinked" class="text-warning text-sm">No billing address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    <div style="font-size:85%">Delivery Address</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select
                          :options="data_option_delivery_address"
                          v-model="deliveryAddressId"
                        / :disabled="addressesLoading">
                        <!-- L'operation n'a pas d'adresse liee : on le DIT, au lieu de
                             choisir une adresse quelconque du client a sa place. -->
                        <span v-if="deliveryAddressUnlinked" class="text-warning text-sm">No delivery address is recorded on this operation. The field above is only a suggestion: check it before saving.</span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    <div style="font-size:85%">Incoterms</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select
                          :options="incotermOptions"
                          v-model="IncotermId"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="w-full mt-4">
                    <div style="font-size:85%">VAT (%)</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-input
                          v-validate="'required|decimal'"
                          v-model="dataTva"
                          class="w-full"
                          name="tva"
                        />
                        <span
                          v-show="errors.has('tva')"
                          class="text-danger"
                        >{{ errors.first('tva') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <template>
                <div id="data-list-list-view" class="data-list-container">
                  <data-view-sidebar
                    :isSidebarActive="addNewDataSidebar"
                    @closeSidebar="toggleDataSidebar"
                    :data="sidebarData"
                  />

                  <vs-table ref="table" :data="products">
                    <div
                      slot="header"
                      class="flex flex-wrap-reverse items-center flex-grow justify-between"
                    >
                      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                        <!-- ACTION - DROPDOWN -->

                        <!-- ADD NEW -->
                        <div
                          class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                          @click="addNewData"
                        >
                          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                          <span class="ml-2 text-base text-primary">Add Product</span>
                        </div>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th>#</vs-th>
                      <vs-th>Category Product</vs-th>
                      <vs-th>Name</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Unit Cost (EUR/UoM)</vs-th>
                      <vs-th>Unit of Measure</vs-th>
                      <vs-th>Volume Unit (m3/UoM)</vs-th>
                      <vs-th>Volume Total (m3)</vs-th>
                      <vs-th>Total Cost (EUR)</vs-th>
                      <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                            <p class="font-medium truncate">{{ indextr+1 }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.productcategory.name_en }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ tr.name }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ Math.abs(tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>

                          <vs-td>
                            <p>{{ Math.abs(tr.operations_products.unit_price).toFixed(4) }}</p>
                          </vs-td>

                          <vs-td>{{ tr.uomsreference.name_en }}</vs-td>

                          <vs-td>
                            <p>{{ Math.abs(tr.volume).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td>
                            <p>{{ Math.abs(tr.volume*tr.operations_products.quantity).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td>
                            <p>{{ Math.abs(tr.operations_products.quantity*tr.operations_products.unit_price).toFixed(4) }}</p>
                          </vs-td>
                          <vs-td class="whitespace-no-wrap">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="editData(tr)"
                            />
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2"
                              @click.stop="deleteProduct(tr.id,tr.name)"
                            />
                          </vs-td>
                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>

                  <div class="w-full mt-16">
                    <div style="font-size:75%">Bottom Mail Template</div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <v-select :options="data_option_bottom_mail_template" v-model="bottomMailTemplateId" @input="writeBottomMailTemplate();"/>
                      </div>
                    </div>
                  </div>
                <div class="w-full mt-0 md:w-full">
                  <vs-textarea
                    style="height:auto"
                    rows="5"
                    class="w-full mt-10"
                    label="Bottom mail"
                    v-model="operation_data.mail_bottom"
                  />
                </div>
              </template>
              <!-- Save & Reset Button -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button
                      v-if="operation_data.isactive"
                      type="border"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="confirmDeleteRecord"
                    >Disable</vs-button>
                    <vs-button
                      v-else
                      type="border"
                      color="success"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="confirmEnableRecord"
                    >Enable</vs-button>&nbsp;&nbsp;
                    <vs-button
                      class="ml-auto"
                      color="success"
                      @click="save_changes"
                      :disabled="!validateForm || addressesLoading"
                    >Save Changes</vs-button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import { takePersonOption } from "@/helpers/personOption";
import Datepicker from "vuejs-datepicker";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import addressSelection from "@/mixins/addressSelection";
import pricingZones from "@/mixins/pricingZones";
import moment from "moment";

export default {
  mixins: [pricingZones, addressSelection],
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      personId: null,
      producttodelete: null,
      statusId: null,
      data_option_payment_status: [],
      data_option_billing_address: [],
      data_option_delivery_address: [],
      billingAddressId: null,
      deliveryAddressId: null,
      dataTva: null,
      dataInvoicePrefix: null,
      dataInvoiceNr: null,
      data_option_bottom_mail_template : [{
        value: 1,
        label: "Invoice Round Stakes Belgique"
      },{
        value: 2,
        label: "Invoice Round Stakes Romania"
      },{
        value: 3,
        label: "Invoice Round Stakes English"
      }
      ],
      bottomMailTemplateId: null,
      IncotermId:
      {
        value: "DAP - Delivered at Place",
        label: "DAP - Delivered at Place"
      },
      dataAdvanceEur: 0,
      dataAdvancePct: 0
    };
  },
  computed: {
    products() {
      return this.$store.state.operationList.operationproducts;
    },
    validateForm() {
      return !this.errors.any();
    },
    currentPage() {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.operation_data.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
  },
  methods: {
    // Sélectionne l'incoterm enregistré sur l'opération. Une valeur absente de la liste
    // (libellé de zone dynamique "DAP BENELUX", ancien "EXW"…) est CONSERVÉE telle quelle :
    // avant, elle tombait dans un else qui la réécrivait silencieusement en
    // "CPT - Carriage Paid To" dès le premier enregistrement.
    applyStoredIncoterm() {
      const stored = (this.operation_data && this.operation_data.incoterms)
        ? String(this.operation_data.incoterms).trim()
        : "";
      if (!stored) {
        this.IncotermId = { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
        return;
      }
      const known = (this.incotermOptions || []).filter((o) => o.value === stored)[0];
      if (known) {
        this.IncotermId = known;
        return;
      }
      // Anciennes écritures non canoniques : on recale sur l'option équivalente.
      if (stored.includes("Free")) {
        this.IncotermId = { value: "FCA - Free Carrier", label: "FCA - Free Carrier" };
      } else if (stored.includes("Carriage")) {
        this.IncotermId = { value: "CPT - Carriage Paid To", label: "CPT - Carriage Paid To" };
      } else if (stored.includes("Delivered at Place")) {
        this.IncotermId = { value: "DAP - Delivered at Place", label: "DAP - Delivered at Place" };
      } else {
        this.IncotermId = { value: stored, label: stored };
      }
    },
    calculateAdvanceFromPctInput() {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then(res => {
            this.m3difference = res;
            this.dataAdvanceEur = this.m3difference/100*this.dataAdvancePct
          })
          .catch(err => {
            console.error(err);
          });
    },
    calculateAdvanceFromEurInput() {
        this.$store
          .dispatch(
            "operationList/fetcheurdifference",
            this.$route.params.userId
          )
          .then(res => {
            this.m3difference = res;
            this.dataAdvancePct = (this.dataAdvanceEur/this.m3difference)*100
          })
          .catch(err => {
            console.error(err);
          });
    },
    writeBottomMailTemplate() {
        if(this.bottomMailTemplateId.value === 1)
        {
          this.operation_data.mail_bottom = 
          "Détails :\n   - Essence de bois : Robinia Pseudoacacia\n   - Piquets ronds, écorcés, pointés (4 faces), diamètre mesuré au milieu\n   - Déchargement du camion à réaliser par le client\n   - Paiement à la commande\n   - Délais de livraison: 30 jours (pour les groupages, cela peut prendre un peu plus de temps)\n\nEn passant commande, vous acceptez sans réserve les conditions générales de ventes qui peuvent à tout moment être consultées sur\nnotre site internet (www.acaciabois.com/conditions-generales-de-ventes)\nLes livraisons intracommunautaire sont exonérées de TVA."
        }
        else if(this.bottomMailTemplateId.value === 2)
        {
           this.operation_data.mail_bottom = 
          "Detalii: \n   - Gen de lemn: Robinia Pseudoacacia\n   - Mize rotunde, decojite, ascuțite (4 laturi), diametru măsurat la mijloc\n   - Descărcarea camionului care urmează să fie efectuată de client\n   - Plata la comandă\n   - Termen de livrare: 30 de zile (pentru grupare, poate dura puțin)\n\nPentru plasarea unei comenzi, acceptați fără rezerve condițiile generale de vânzare care pot fi consultate oricând pe site-ul nostru\nLivrările comunitare sunt scutite de TVA."
        }
        else if(this.bottomMailTemplateId.value === 3)
        {
           this.operation_data.mail_bottom = 
          "Details: \n   - Type of wood: Robinia Pseudoacacia\n   - Round stakes, peeled, pointed (4 sides), diameter measured in the middle\n   - Unloading to be carried out by the customer\n   - Payment on order\n   - Delivery times: 30 days (for groupage, it may take a little longer)\n\nBy ordering, you unreservedly accept the general terms and conditions of sale which can be consulted at any time on our website\n(www.acaciabois.com/conditions-generales-de-vente)\nIntracommunity deliveries are exempt from VAT."
        }
    },
    isInt(n) {
      return n === +n && n === (n|0);
    },
    changeDateInvoice() {
      this.dataInvoicePrefix =
        "EU " +
        moment(this.operation_data.date).add(12, "hours").format("YYYY");
    },
    async getNewInvoiceNr() {
      if (!this.dataInvoiceNr) {
        let NextInvoiceNr = null;
        axios
          .get(
            "/sale/getnextinvoicenr/" +
              moment(this.operation_data.date).add(12, "hours").format("YYYY")
          )
          .then((response) => {
            try {
              if (this.data_option_billing_address[0].label.includes('Romania'))
              {
                this.dataInvoiceNr = response.data.next_invoice_no.ro;
              }
              else
              {
                this.dataInvoiceNr = response.data.next_invoice_no.eu;
              }
            } catch (error) {
            }
          })
          .catch((error) => {
          });
      }
    },
    // Les deux listes d'options d'abord (Promise.all), la selection ENSUITE.
    // Avant, la resolution de la selection etait lancee depuis chacun des deux
    // .then() : quatre requetes concurrentes, et la premiere tournait contre une
    // liste d'options encore vide. Deux vagues, un seul ordre possible.
    //
    // `personChanged` = le contact vient d'etre change dans le v-select. On ne
    // relit alors PAS l'adresse liee a l'operation : elle appartient encore a
    // l'ANCIEN contact, et la reinjecter dans les options du nouveau est
    // exactement le « l'adresse a saute » signale. On propose l'adresse par
    // defaut du nouveau contact, visible dans le v-select avant tout Save.
    async getBillingAndDeliveryAddressList(personChanged = false) {
      this.billingAddressId = null;
      this.deliveryAddressId = null;
      this.billingAddressUnlinked = false;
      this.deliveryAddressUnlinked = false;
      this._beginAddressLoading();
      // Sans contact, il n'y a pas d'adresse a charger : ne pas dereferencer
      // this.personId.value (TypeError silencieux qui laissait le drapeau de
      // chargement a vrai, donc le bouton Save grise pour toujours).
      if (!this.personId || this.personId.value === null || this.personId.value === undefined) {
        this.data_option_billing_address = [];
        this.data_option_delivery_address = [];
        this._endAddressLoading();
        return;
      }
      try {
        const [billing, delivery] = await Promise.all([
          axios.get("/person/getaddressbilling/" + this.personId.value).catch(() => ({ data: [] })),
          axios.get("/person/getaddressdelivery/" + this.personId.value).catch(() => ({ data: [] })),
        ]);
        this.data_option_billing_address = [...((billing && billing.data) || [])];
        this.data_option_delivery_address = [...((delivery && delivery.data) || [])];
        if (!this.dataInvoiceNr) this.getNewInvoiceNr();
        await this.getSelectedBillingAndDeliveryAddressList(personChanged);
      } finally {
        this._endAddressLoading();
      }
    },
    // `personChanged` : voir getBillingAndDeliveryAddressList. Les deux
    // chaines sont RENVOYEES, donc reellement attendues par l'appelant —
    // avant, elles partaient en fire-and-forget et le drapeau de chargement
    // retombait a faux alors que les adresses n'etaient pas encore resolues.
    async getSelectedBillingAndDeliveryAddressList(personChanged = false) {
      const billingChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressbilling/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.billingAddressId = this.pickAddressOption(this.data_option_billing_address, selectedAddress);
            this.billingAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.billingAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.billingAddressId)
            {
              this.billingAddressId = this.proposeAddressOption(this.data_option_billing_address);
              if (this._firstAddressLabel(this.data_option_billing_address).includes("Belgium"))
              {
                this.dataTva = "21"
              }
            }
          });

      const deliveryChain = (personChanged
          ? Promise.reject(new Error("contact changed: no linked address to re-read"))
          : axios.get("/person/getaddressdelivery/" + this.personId.value + "/" + this.$route.params.userId))
          .then((response) => {
            // The address this operation is actually linked to. pickAddressOption
            // injects it when it is missing from the options instead of silently
            // selecting options[0] — which was then saved over the real address.
            const selectedAddress = response.data[0];
            if (!selectedAddress || selectedAddress.value == null)
              throw new Error("no address linked to this operation");
            this.deliveryAddressId = this.pickAddressOption(this.data_option_delivery_address, selectedAddress);
            this.deliveryAddressUnlinked = false;
          })
          .catch((error) => {
            // Ne l'annoncer que quand c'est VRAI : un echec reseau tombe dans ce
            // meme catch, et dire alors « aucune adresse enregistree » serait faux.
            this.deliveryAddressUnlinked = /no address linked|contact changed/.test(
              (error && error.message) || "");
            if (!this.deliveryAddressId)
              this.deliveryAddressId = this.proposeAddressOption(this.data_option_delivery_address);
          });

      return Promise.all([billingChain, deliveryChain]);
    },
    getMaxInventoryDate() {
      var dateStop = moment(this.dataDate)
        .add(12, "hours")
        .format("YYYY-MM-DD");
      axios.get("/getmaxinventorydate").then((response) => {
        this.maxdateoperation = response.data;
      });
    },
    async getPaymentStatus() {
      axios.get("/salestatus/data").then((response) => {
        this.data_option_payment_status = [...response.data];
        if (this.operation_data.salestatus) {
          const ItemIndex = this.data_option_payment_status.findIndex(
            (p) => p.value === this.operation_data.salestatus.id
          );
          this.statusId = this.data_option_payment_status.splice(ItemIndex, 1);
        } else {
          this.statusId = this.data_option_payment_status.splice(2, 1);
        }
      });
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        // Le contact du document, même inactif — jamais le dernier de la liste (helpers/personOption).
        this.personId = takePersonOption(this.data_option_people_name, this.operation_data.people[0]);
        this.getBillingAndDeliveryAddressList();
      });
    },
    confirmDeleteRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert =
        this.operation_data.operationcategory.name_en +
        " #" +
        this.operation_data.id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      axios
        .post("/operation/enable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/sale/" + this.operation_data.id });
      this.showEnableSuccess();
    },
    // Les .catch vides masquaient tout echec de /operation/enable|disable :
    // l'ecran affichait « successfully deleted » et l'operation etait toujours la.
    showActionFailed(err) {
      console.error("operation enable/disable:", err);
      const data = err && err.response && err.response.data;
      this.$vs.notify({
        color: "danger",
        title: "Action NOT applied",
        text: (data && (data.message || data.error)) || (err && err.message) ||
          "The server refused the operation. Reload the page to see its real state.",
        time: 12000,
      });
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Enable",
        text: "The selected operation was successfully enabled",
      });
    },
    deleteRecord() {
      axios
        .post("/operation/disable", { id: this.operation_data.id })
        .catch((err) => {
          this.showActionFailed(err);
        });
      this.$router.push({ path: "/sale/" + this.operation_data.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Operation Deleted",
        text: "The selected operation was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    addNewData() {
      if (this.operation_data.id) {
        var idoperation = this.operation_data.id;
        this.sidebarData = { idoperation };
        this.toggleDataSidebar(true);
      }
    },
    save_changes() {
      // Un enregistrement lance pendant le chargement des adresses partait avec
      // une adresse nulle — ou pire, celle de l'ANCIEN contact.
      const addressBlocked = this.addressSaveBlockReason();
      if (addressBlocked) {
        this.$vs.notify({ color: "warning", title: "Please wait", text: addressBlocked });
        return;
      }
      /* eslint-disable */
      let _idbilling = null; 
      if (this.billingAddressId) {
        _idbilling = this.billingAddressId.value;
      }
      let _iddelivery = null;
      if (this.deliveryAddressId) {
        _iddelivery = this.deliveryAddressId.value;
      }
      let _incoterms = null;
      if (this.IncotermId) _incoterms = this.IncotermId.value
      const obj = {
        id: this.operation_data.id,
        idperson: this.personId.value,
        idsalestatus: this.statusId.value,
        date: moment(this.operation_data.date),
        tva: this.dataTva,
        mail_bottom: this.operation_data.mail_bottom,
        iddelivery: _iddelivery,
        idbilling: _idbilling,
        invoice_no: this.dataInvoiceNr,
        incoterms: _incoterms,
        acompte_amount: this.dataAdvanceEur
      };
      if (this.operation_data.id) {
        this.$store
          .dispatch("operationList/updateOperation", obj)
          .catch((err) => {
            console.error(err);
          });
        this.$router.push({ path: "/sale/" + this.operation_data.id });

        this.$vs.notify({
          color: "success",
          title: "Operation Updated!",
          text: "The operation was successfully updated",
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The Product was successfully deleted",
      });
    },
    deleteProductOne() {
      /*alert("idaddress"+this.addresstodelete)
      alert("idperson"+this.operation_data.id)*/
      const obj = {
        idproduct: this.producttodelete,
        idoperation: this.operation_data.id,
        who: localStorage.getItem("login-username"),
      };
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
      this.$store.dispatch("operationList/removeItem", obj).catch((err) => {
        console.error(err);
      });
      //refresh view after delete
      this.$store
        .dispatch("operationList/fetchm3difference", this.$route.params.userId)
        .then((res) => {
          //this.m3difference = res;
          //console.log(this.$store._vm._data.$$state.operationList.m3difference)
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
      this.showDeleteAddressSuccess();
    },
    deleteProduct(id, name) {
      this.producttodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: "Delete Product",
      });
    },
    editData(data) {
      /* this.$store.dispatch('operationList/updateOperation', obj).catch(err => { console.error(err) })*/
      data.idperson = this.operation_data.id;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_operation_data(userId) {
      if (userId) {
        this.$store
          .dispatch("operationList/fetchOperation", userId)
          .then((res) => {
            this.operation_data = res.data;
            this.getPeople();
            this.getPaymentStatus();
            if (this.operation_data.products.length > 0) this.dataTva = this.operation_data.products[0].operations_products.tva_pct;
            this.dataInvoicePrefix =
              "EU " +
              moment(this.operation_data.date).add(12, "hours").format("YYYY");
            this.dataInvoiceNr = this.operation_data.invoice_no;
            //if (!this.dataInvoiceNr) this.getNewInvoiceNr();
            this.applyStoredIncoterm();
            if (this.operation_data.acompte_amount)
            {
              this.dataAdvanceEur = this.operation_data.acompte_amount
              this.calculateAdvanceFromEurInput()
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.user_not_found = true;
              return;
            }
            console.error(err);
          });
      } else {
        this.operation_data = {};
      }
    },
    fetch_product_data(userId) {
      if (userId) {
        this.$store.dispatch("operationList/fetchOperationProducts", userId);
      } else {
        this.product_data = {};
      }
    },
  },

  created() {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }
    this.fetch_operation_data(this.$route.params.userId);
    this.fetch_product_data(this.$route.params.userId);
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

